import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-validation',
  template: `
    <p>
      validation works!
    </p>
  `,
  styles: []
})
export class ValidationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
